export default "__VITE_ASSET__C3Z$Tbll__"